module.exports = __webpack_public_path__ + "img/bth_bed_left_tunbu_sel.b756accb.png";